import { l as e } from "../../../../_virtual/leaflet-src.js";
const t = e.divIcon({
  className: `
    relative
    w-5 h-5
    bg-blue-200
    rounded-full
    border-[3px] border-blue-500
    shadow-md
    transition-transform
    hover:bg-blue-500
    hover:scale-125
  `,
  iconSize: [20, 20],
  iconAnchor: [10, 10]
}), n = (o) => e.divIcon({
  html: `<div class="cluster-icon bg-blue-500 text-white text-lg font-semibold rounded-full flex justify-center items-center w-10 h-10 -ml-[50%]">${o.getChildCount()}</div>`,
  className: "cluster-icon-container",
  iconSize: [20, 20],
  iconAnchor: [10, 10]
});
export {
  n as createClusterIcon,
  t as markerIcon
};
